export const defaultPaidMediaColumns = [
  { title: 'Backlog', description: 'Campanhas mapeadas que ainda não entraram em pauta' },
  { title: 'Priorizadas', description: 'Campanhas na sprint atual do time da Ecto' },
  { title: 'Para alinhar', description: 'Campanhas que precisam ser alinhadas antes da ativação' },
  {
    title: 'Para publicar',
    description: 'Campanhas que estão aprovadas e prontas para a publicação',
  },
  { title: 'Ativas', description: 'Campanhas ativas nesse momento' },
  { title: 'Finalizadas', description: 'Campanhas inativas e finalizadas' },
  {
    title: 'Arquivadas',
    description: 'Campanhas pausadas por questões estratégicas, priorização ou fatores externos',
  },
];
